import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import {} from 'react-redux';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  CartesianGrid,
} from 'recharts';

const ClassWiseEnrollment = ({ Data }) => {
  const [EnrollmentDetails, setEnrollmentDetails] = useState([]);

  useEffect(() => {
    setEnrollmentDetails(Data ?? []);
  }, [Data]);
  return (
    <div className='bg-white rounded-lg shadow-sm  size-full'>
      <div className=' p-2 mb-2'>
        <Typography variant='h6' className='w-96 '>
          Class-Wise Enrollment
        </Typography>
      </div>
      {EnrollmentDetails?.length !== 0 ? (
        <div className='overflow-auto w-full'>
          <div
            style={{
              '----w': `${(EnrollmentDetails?.length > 5 ? EnrollmentDetails.length : 6) * 80}px`,
            }}
            className='w-[var(----w)] mx-auto'
          >
            <ResponsiveContainer height={260} className=''>
              <BarChart data={EnrollmentDetails} className='pr-5'>
                <XAxis dataKey='class' interval={0} tick={{ fontSize: 12 }} />
                <YAxis domain={[0, 100]} />
                <Tooltip
                  cursor={false}
                  content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                      return (
                        <div className='bg-white shadow-lg rounded-md p-3 border text-sm'>
                          <div className='font-semibold mb-1'>{label}</div>
                          <div className='text-blue-600'>
                            Count: {payload?.[0]?.value}
                          </div>
                        </div>
                      );
                    }

                    return null;
                  }}
                />{' '}
                <CartesianGrid
                  stroke='#e5e7eb'
                  strokeDasharray='3 3'
                  vertical={false}
                />
                <Bar
                  dataKey='count'
                  fill='#8dc1ff'
                  radius={[5, 5, 0, 0]}
                  barSize={18}
                  activeBar={{ fill: '#6aaeff' }} // hover color
                />
                <Legend
                  content={
                    <div className='flex gap-2  items-center justify-center'>
                      {' '}
                      <span className='w-5 h-3 rounded-full bg-[#8dc1ff]'></span>{' '}
                      <span>Number of Students</span>
                    </div>
                  }
                />
              </BarChart>
            </ResponsiveContainer>{' '}
          </div>
        </div>
      ) : (
        <div className='size-full h-72 flex justify-center items-center'>
          No Enrollment Details
        </div>
      )}
    </div>
  );
};

export default ClassWiseEnrollment;
